import {Injectable} from '@angular/core';
import * as firebase from 'firebase';
import {UserService} from './user.service';
import {UserModel} from '../models/user.model';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public isAuth = false;
  public isAdmin = false;
  public isSuperAdmin = false;
  public isClient = false;
  public isEnqueteur = false;
  public uid = null;
  public user = null;
  public profile = -1;
  public isProspect = false;
  public isWelcome = false;
  public userwithGooleAccount: UserModel;
  constructor(private userService: UserService) {
    //this.getAuthorisation();
  }

  createNewUser(email: string, password: string) {
    return new Promise(
      ((resolve, reject) => {
        firebase.auth().createUserWithEmailAndPassword(email, password).then(
          (newUser) => {
            resolve(newUser.user);
          },
          (error) => {
            reject(error);
          }
        );
      })
    );
  }

  signInUser(email: string, password: string) {
    return new Promise<void>(
      (resolve, reject) => {
        firebase.auth().signInWithEmailAndPassword(email, password).then(
          () => {
            resolve();
          },
          (error) => {
            reject(error);
          }
        );
      }
    );
  }

  signInAnonymously() {
    return new Promise<any>(
      (resolve, reject) => {
        firebase.auth().signInAnonymously().then(
          (credential) => {
            resolve(credential);
          }, (error) => {
            reject(error);
          }
        );
      }
    );
  }

  signOutUser() {
    firebase.auth().signOut();
  }

  getAuthorisation(user: any) {
    return this.userService.getSingleUser(user.uid)
      .then((utilisateur: any) => {
          this.uid = utilisateur.uid;
          this.user = utilisateur;
          this.profile = utilisateur.profil;
          this.isAuth = true;
          if (utilisateur.profil === 1) {
            this.isAdmin = true;
            this.isSuperAdmin = true;
            return true;
          } else if (utilisateur.profil === 2) {
            this.isClient = true;
            return true;
          } else if (utilisateur.profil === 20) {
            this.isProspect = true;
            return true;
          } else {
            this.isEnqueteur = true;
            return false;
          }
        },
        (error) => {
          return false;
        }
      )
      .catch(
        (error) => {
          return false;
        }
      );
  }


}
